/*
 * @Author: your name
 * @Date: 2021-12-16 15:02:29
 * @LastEditTime: 2022-04-29 17:22:57
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \sz2\src\utils\request.js
 */
/* jshint esversion:6 */
import axios from 'axios';
import cookie from 'cookie_js';
//https://sz.shawcoder.xyz/webserver   http://localhost:8096
const service = axios.create({
  baseURL: "https://sz.shawcoder.xyz/webserver",
  timeout: 60000,
});

/**
 * 请求拦截器
 */
service.interceptors.request.use(config => {
  // 发送请求前处理
  let userid = cookie.get('userid');
  if(userid) {
      config.headers.userid = userid;
  }
  var token = localStorage.getItem("sz_token");
  // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI4NGQxMTJiMjkyMWI0ZDY4OTUxNjk2ZWIyYmEwMjAzMiJ9.4ckEgMWd3a8E5GaXnCHFes-8C6fWLF_j6mkctSjJSRM'
  config.headers.userid = token
  config.headers.token = token
  return config;
}, error => {
  // 请求错误时处理
  return Promise.reject(error);
});

/**
 * 响应拦截器
 */
service.interceptors.response.use(response => {
  // 响应接收后处理
  // if(response.data.code == 501) {
  //     sessionStorage.removeItem('login');
  //     cookie.remove('login');
  //     cookie.remove('name');
  //     cookie.remove('userid');
  //     location.reload();
  // }
  return response;
}, error => {
  // 响应错误时处理
  return Promise.reject(error);
});

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js



// WEBPACK FOOTER //
// ./src/utils/request.js